import Utils from "../utils/Utils";
const PromotionController = {
  addCampaign: ({ Authorization, request }) => {
    return Utils.controller(
      "api/promotion/v1/addCampaign",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  getFeaturedByProductOfferId: ({ Authorization, productOfferId }) => {
    return Utils.controller(
      "api/featured/v1/getFeaturedByProductOfferId",
      "",
      "GET",
      `productOfferId=${productOfferId}`,
      true,
      Authorization,
      true,
    );
  },
  addFeatured: ({ Authorization, request }) => {
    return Utils.controller(
      "api/featured/v1/addFeatured",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
  getAllBillingPlans: ({ Authorization }) => {
    return Utils.controller(
      "api/billingPlan/v1/getAllBillingPlans",
      "",
      "GET",
      "",
      true,
      Authorization,
      true,
    );
  },
  getPlansAndBilling: ({ Authorization, companyId }) => {
    return Utils.controller(
      "api/promotion/v1/getPlansAndBilling",
      "",
      "GET",
      `companyId=${companyId}`,
      true,
      Authorization,
      true,
    );
  },
  deletePromotionByProductOfferId: ({ Authorization, productOfferId }) => {
    return Utils.controller(
      "api/promotion/v1/deletePromotionByProductOfferId",
      "",
      "DELETE",
      `productOfferId=${productOfferId}`,
      true,
      Authorization,
      true,
    );
  },
  deleteFeaturedByProductOfferId: ({ Authorization, productOfferId }) => {
    return Utils.controller(
      "api/featured/v1/deleteFeaturedByProductOfferId",
      "",
      "DELETE",
      `productOfferId=${productOfferId}`,
      true,
      Authorization,
      true,
    );
  },
  editPromotion: ({ Authorization, request }) => {
    return Utils.controller(
      "api/promotion/v1/editPromotion",
      request,
      "PUT",
      "",
      true,
      Authorization,
      true,
    );
  },
  buyCredits: ({ Authorization, request }) => {
    return Utils.controller(
      "api/credit/v1/buyCredits",
      request,
      "POST",
      "",
      true,
      Authorization,
      true,
    );
  },
};

export default PromotionController;
